export const isWindowWithinIFrame = () => {
    return typeof window !== 'undefined' && window.self !== window.top;
};
// Detects whether this page is running inside a host container.
// Used only to switch between standalone and embedded rendering mode —
// not for any security or auth decision.
//
// Three hosting surfaces are covered:
//   1. storable.mfeHost  — injected by the @storable/mfe host SDK before the page loads
//   2. chrome.webview    — present in Edge WebView2 / CEF native desktop shells
//   3. window !== top    — classic HTML <iframe> embedding
//
// Note: these globals could in theory be spoofed by a page script, but
// the consequence is only a UI mode switch, so the risk is acceptable.
export const isWindowWithinHostedContext = (): boolean => {
    if (typeof window === 'undefined') return false;

    if ((window as any).storable?.mfeHost) return true;

    if ((window as any).chrome?.webview) return true;

    if (window.self !== window.top) return true;

    return false;
};
